import {Row,message} from 'antd';
import classes from '../Pages.module.css';
import DataField from './DataField';

const OtherDetails = (props) => {

    const handleChange = (e,param) => {

        props.setData(data => {
            const newdata = [...data['employeeMaster']]
            newdata[0][param] = e.target.value
            return({
                ...data,
                employeeMaster : newdata
            })
        })
    }

    const handleDChange = (date, dateString, param) => {

        props.setData(data => {
            const newdata = [...data['employeeMaster']]
            newdata[0][param] = dateString
            return({
                ...data,
                employeeMaster : newdata
            })
        })
    }

    const handleDateOfBirthChange = (date, dateString, param) => {
        const today = new Date();
        const birthDate = new Date(dateString);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        
        if (age >= 18) {
          handleDChange(date, dateString, param);
        } else {
          message.error('You must be at least 18 years old.');
        }
      };
      

    const handleSChange = (val,param) => {

        props.setData(data => {
            const newdata = [...data['employeeMaster']]
            newdata[0][param] = val
            return({
                ...data,
                employeeMaster : newdata
            })
        })
    }

    return(
        <div>
        <p></p>
        <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleDateOfBirthChange} 
                type="Date" 
                name="date of birth" 
                required={true}
                param="dob" 
                value={props.data.dob} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleSChange} 
                options={props.ad.GENDER} 
                type="Select" 
                name="gender" 
                required={true}
                param="sex" 
                value={props.data.sex} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="father's name" 
                param="father_name" 
                value={props.data.father_name} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="mother's name" 
                param="mother_name" 
                value={props.data.mother_name} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleSChange} 
                options={props.ad.RELIGION_CODE} 
                type="Select" 
                name="religion" 
                param="religion_code" 
                value={props.data.religion_code} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="nationality" 
                param="nationality" 
                value={props.data.nationality} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleDChange} 
                type="Date" 
                name="wedding date" 
                param="dow" 
                value={props.data.dow} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleSChange} 
                options={props.ad.MARITIAL_STATUS} 
                type="Select" 
                name="marital status" 
                param="marital_status" 
                value={props.data.marital_status} 
            />
        </Row>
        <p></p>
        <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="blood group" 
                param="blood_group" 
                value={props.data.blood_group} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleSChange} 
                options={props.ad.HANDICAPPED} 
                type="Select" 
                name="handicapped" 
                param="handicapped" 
                value={props.data.handicapped} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="height" 
                param="height" 
                value={props.data.height} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="weight" 
                param="weight" 
                value={props.data.weight} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="mediclaim" 
                param="mediclaim_amount" 
                value={props.data.mediclaim_amount} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="dispensary" 
                param="dispensary" 
                value={props.data.dispensary} 
            />
        </Row>
        <p></p>
        <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="bank name" 
                param="bank_name" 
                value={props.data.bank_name} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="branch" 
                param="branch_address" 
                value={props.data.branch_address} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleChange} 
                name="name in bank" 
                param="name_in_bank" 
                value={props.data.name_in_bank} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleChange} 
                name="ifsc code" 
                param="ifsc_code" 
                value={props.data.ifsc_code} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleChange} 
                name="account no." 
                param="bank_account_no" 
                value={props.data.bank_account_no} 
            />
        </Row>
        <p></p>
        <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="file no." 
                param="file_no" 
                value={props.data.file_no} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="esi no." 
                param="esi_number" 
                value={props.data.esi_number} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="pan no." 
                param="pan_number" 
                value={props.data.pan_number} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="card no." 
                param="card_no" 
                value={props.data.card_no} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="provident fund no." 
                param="provident_fund_no" 
                value={props.data.provident_fund_no} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="uan" 
                param="uan" 
                value={props.data.uan} 
            />
        </Row>
        <p></p>
        <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleDChange} 
                type="Date" 
                name="joining date" 
                required={true}
                param="doj" 
                value={props.data.doj} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleDChange} 
                type="Date" 
                name="leaving date" 
                param="dol" 
                value={props.data.dol} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleDChange} 
                type="Date" 
                name="confirmation date" 
                param="doc" 
                value={props.data.doc} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="insurance amount" 
                param="insurance_amount" 
                value={props.data.insurance_amount} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="term insurance value" 
                param="term_insurance_value" 
                value={props.data.term_insurance_value} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="term insurance premium" 
                param="term_insurance_premium" 
                value={props.data.term_insurance_premium} 
            />
        </Row>
        <p></p>
        <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleChange} 
                name="report to" 
                param="reporting_to" 
                value={props.data.reporting_to} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleChange} 
                name="reference" 
                param="reference" 
                value={props.data.reference} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleChange} 
                name="over time" 
                param="overtime" 
                value={props.data.overtime} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="probation period" 
                param="probation_period" 
                value={props.data.probation_period} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                name="distance from native" 
                param="distance_from_native" 
                value={props.data.distance_from_native} 
            />
        </Row>
        <p></p>
    </div>
    
    );
}

export default OtherDetails